import Popup from 'components/popups/Popup'
import React from 'react'
import Player from '.'

interface CameraModalProps {
  name?: string
  camera: basic.CameraData
}

const CameraModal: React.FC<CameraModalProps> = ({ name, camera }) => {
  return (
    <Popup>
      <div className='cam__modal'>
        <div className='popup__title'>
          <div>{name}</div>
        </div>
        <Player camera={camera} />
      </div>
    </Popup>
  )
}

export default CameraModal